import axios from 'axios';
import { IHistoryCollectionDto } from 'app/models/history.models';

const basePath = '/events';

export const historyService = {
  getHistory: (eventId: number): Promise<IHistoryCollectionDto> => axios.get(`${basePath}/${eventId}/histories`),
};
